import React from 'react';
import TopicCard from '../components/TopicCard/TopicCard';
import styles from './Pages.module.css';

const GraphPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Graphs</h1>
      <p className={styles.subtitle}></p>
      <div className={styles.cardContainer}>
        <TopicCard
          title="Undirected Graph"
          description="A graph where edges have no direction — connections flow both ways between nodes."
          link="/graph/undirected"
          icon="🧮"
        />
        <TopicCard
          title="Directed Graph"
          description="A graph where edges point in one direction, creating one-way relationships between nodes."
          link="/graph/directed"
          icon="🔢"
        />
        <TopicCard
          title="Dijkstra Shortest Path"
          description="Finds the shortest path between nodes in a weighted graph using a priority-based search."
          link="/graph/dijkstra"
          icon="🔁"
        />
          <TopicCard
          title="Compare Graphs"
          description="See how undirected, directed, and weighted graphs differ in structure and traversal behavior."
          link="/graph/comparegraphs"
          icon="⚖️"
        />
      </div>
    </div>
  );
};

export default GraphPage;